import React, { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import SportIcon from "../components/SportIcon";

export default function Rankings() {
  const [sports, setSports] = useState([]);
  const [slug, setSlug] = useState("padel");
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/sports").then((r) => setSports(r.data)); }, []);
  useEffect(() => { api.get(`/rankings/${slug}`).then((r) => setRows(r.data)); }, [slug]);

  return (
    <AppLayout>
      <h1 className="font-heading text-3xl sm:text-4xl font-black flex items-center gap-3"><Trophy size={28} className="text-[#00E676]" /> Rankings</h1>
      <p className="text-zinc-400 mt-2">Global ELO rankings across the platform.</p>
      <div className="mt-6 flex flex-wrap gap-2" data-testid="rankings-sport-filter">
        {sports.map((s) => (
          <button key={s.id} onClick={() => setSlug(s.slug)} data-testid={`rank-sport-${s.slug}`} className={`pp-chip ${slug === s.slug ? "pp-chip-active" : ""}`}>
            <SportIcon slug={s.slug} size={14} /> {s.name}
          </button>
        ))}
      </div>

      <div className="mt-6 pp-card p-6">
        <table className="w-full text-sm" data-testid="rankings-table">
          <thead className="text-xs uppercase tracking-wider text-zinc-500">
            <tr><th className="text-start py-2">#</th><th className="text-start">Player</th><th className="text-start">Country</th><th className="text-end">ELO</th></tr>
          </thead>
          <tbody>
            {rows.map((p, i) => (
              <tr key={p.id} className="border-t border-white/5">
                <td className="py-2 text-zinc-500">{i + 1}</td>
                <td>{p.first_name} {p.last_name}</td>
                <td className="text-zinc-400">{p.country || "—"}</td>
                <td className="text-end font-bold text-[#00E676]">{p.elo}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={4} className="py-6 text-center text-zinc-500">No players yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
